'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButton = exports.getIconDropdown = exports.getButtonDropdown = exports.getMenuItems = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Menu = require('material-ui/Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = require('material-ui/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _Divider = require('material-ui/Divider');

var _Divider2 = _interopRequireDefault(_Divider);

var _RaisedButton = require('material-ui/RaisedButton');

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _ButtonDropdown = require('./ButtonDropdown');

var _ButtonDropdown2 = _interopRequireDefault(_ButtonDropdown);

var _IconDropdown = require('./IconDropdown');

var _IconDropdown2 = _interopRequireDefault(_IconDropdown);

var _Toolbar = require('material-ui/Toolbar');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STYLES = {
  button: {
    margin: '10px'
  },
  leftSeperator: {
    width: '25px',
    display: 'inline-block'
  }
};

var getMenuItems = exports.getMenuItems = function getMenuItems() {
  var items = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

  return items.map(function (item, i) {
    return item.divider ? _react2.default.createElement(_Divider2.default, { key: i }) : _react2.default.createElement(_MenuItem2.default, { key: i, primaryText: item.title, onTouchTap: function onTouchTap() {
        item.handler && item.handler();
      } });
  });
};

var getButtonDropdown = exports.getButtonDropdown = function getButtonDropdown(label) {
  var items = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
  var extraProps = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
  var i = arguments[3];

  return _react2.default.createElement(
    _ButtonDropdown2.default,
    {
      key: i,
      timestamp: new Date().getTime(),
      buttonclass: _RaisedButton2.default,
      buttonprops: _extends({
        label: label,
        style: STYLES.button
      }, extraProps) },
    _react2.default.createElement(
      _Menu2.default,
      null,
      getMenuItems(items)
    )
  );
};

var getIconDropdown = exports.getIconDropdown = function getIconDropdown(icon) {
  var items = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
  var i = arguments[2];

  return _react2.default.createElement(_IconDropdown2.default, {
    key: i,
    icon: icon,
    items: items });
};

var getButton = exports.getButton = function getButton(label, handler) {
  var extraProps = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
  var i = arguments[3];

  return _react2.default.createElement(_RaisedButton2.default, _extends({
    key: i,
    label: label,
    style: STYLES.button,
    onTouchTap: handler
  }, extraProps));
};

var KettleToolbar = function (_Component) {
  _inherits(KettleToolbar, _Component);

  function KettleToolbar() {
    _classCallCheck(this, KettleToolbar);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(KettleToolbar).apply(this, arguments));
  }

  _createClass(KettleToolbar, [{
    key: 'getButtonFromSchema',
    value: function getButtonFromSchema(schema, i) {
      var type = schema.type || 'button';
      if (type == 'dropdown') {
        return getButtonDropdown(schema.title, schema.items, schema.extraProps, i);
      } else if (type == 'button') {
        return getButton(schema.title, schema.handler, schema.extraProps, i);
      } else if (type == 'icon') {
        return getIconDropdown(schema.icon, schema.items, schema.extraProps, i);
      } else {
        console.error('unknown button type: ' + type);
        console.log(JSON.stringify(schema, null, 4));
        return _react2.default.createElement('div', { key: i });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _Toolbar.Toolbar,
        null,
        _react2.default.createElement(
          _Toolbar.ToolbarGroup,
          { key: 0 },
          this.props.title ? _react2.default.createElement(_Toolbar.ToolbarTitle, { text: this.props.title }) : null,
          this.props.title ? _react2.default.createElement(_Toolbar.ToolbarSeparator, null) : null,
          _react2.default.createElement('div', { style: STYLES.leftSeperator }),
          this.props.leftbuttons.map(function (leftButton, i) {
            return _this2.getButtonFromSchema(leftButton, i);
          }),
          this.props.children
        ),
        _react2.default.createElement(
          _Toolbar.ToolbarGroup,
          { key: 1 },
          this.props.rightChildren,
          this.props.rightbuttons.map(function (rightButton, i) {
            return _this2.getButtonFromSchema(rightButton, i);
          })
        )
      );
    }
  }]);

  return KettleToolbar;
}(_react.Component);

KettleToolbar.propTypes = {
  title: _react.PropTypes.string,
  leftbuttons: _react.PropTypes.array,
  rightbuttons: _react.PropTypes.array,
  onButton: _react.PropTypes.func
};

KettleToolbar.defaultProps = {
  title: '',
  leftbuttons: [],
  rightbuttons: [],
  onButton: function onButton() {}
};

exports.default = KettleToolbar;


/** WEBPACK FOOTER **
 ** ../kettle-ui/lib/Toolbar.js
 **/